import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Admin Panel imports
import DashboardLayout from './Componants/AdminPannel/DashboardLayout';
import ContactAdmin from './Pages/AdminPannel/Contact';
import Insights from './Pages/AdminPannel/Insights';
import DashboardHome from './Pages/AdminPannel/DashboardHome';
import GetInTouch from './Pages/AdminPannel/GetInTouch';
import JobOpening from './Pages/AdminPannel/JobOpening';
import Login from './Pages/AdminPannel/Login';
import ProtectedRoute from './Componants/AdminPannel/ProtectedRoute';

// Frontend imports
import Navbar from "./Componants/Navbar";
import Footer from "./Componants/Footer";
import AboutUs from "./Pages/Aboutus/page";
import ContactFrontend from "./Pages/Contact/page";
import Homepage from "./Pages/Home/page";
import Freedemo from "./Pages/Freedemo/page";
import Product from "./Pages/Products/page";
import Service from "./Pages/Services/page";
import Careers from "./Pages/Careers/page";
import JobDetail from './Pages/Careers/JobDetail';
import Blogs from "./Pages/Blogs/page";
import BlogDetail from "./Pages/Blogs/BlogDetail";
import ScrollToTop from './Componants/ScrollTop/ScrollToTop';
import CaseStudies from "./Pages/CaseStudies/page";
import CaseStudyDetail from "./Pages/CaseStudies/CaseStudyDetail";
import News from "./Pages/News/page";
import NewsDetail from "./Pages/News/NewsDetails";

function App() {
  return (
    <Router>
      <ScrollToTop />

      <Routes>
        {/* -------------------- ADMIN ROUTES -------------------- */}
        <Route path="/adminpanel" element={<Login />} />

        <Route
          path="/adminpanel/dashboard/*"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardHome />} />
          <Route path="contact" element={<ContactAdmin />} />
          <Route path="get-in-touch" element={<GetInTouch />} />
          <Route path="blogs" element={<Insights />} />
          <Route path="jobs" element={<JobOpening />} />
        </Route>

        {/* -------------------- FRONTEND ROUTES (Default at "/") -------------------- */}
        <Route
          path="/*"
          element={
            <>
              <Navbar />
              <Routes>
                <Route index element={<Homepage />} />
                <Route path="about-us" element={<AboutUs />} />
                <Route path="freedemo" element={<Freedemo />} />
                <Route path="product" element={<Product />} />
                <Route path="service" element={<Service />} />
                <Route path="contact" element={<ContactFrontend />} />
                <Route path="careers" element={<Careers />} />
                <Route path="careers/:id" element={<JobDetail />} />
                <Route path="blog" element={<Blogs />} />
                <Route path="blog/:id" element={<BlogDetail />} />
                <Route path="casestudies" element={<CaseStudies />} />
                <Route path="case-studies/:id" element={<CaseStudyDetail />} />
                <Route path="news" element={<News />} />
                <Route path="news/:id" element={<NewsDetail />} />
              </Routes>
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
